import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import EmployeeUserManagementContent from './EmployeeUserManagementContent';
import useDebounce from '../../../common/hooks/useDebounce';
import ChangePasswordModal from '../components/ChangePasswordModal';
import CreateEmployeeModal from '../modals/CreateEmployeeModal';
import UpdateEmployeeModal from '../modals/UpdateEmployeeModal';

const INIT_FILTER = {
  sort_by: 'desc',
  q: '',
};

function EmployeeUserManagementContainer({
  match,
  history,
  getUserManagementList,
  userManagementList,
  userManagementListPager,
  isLoading,
  removeUserManagement,
  showUserManagement,
  activateUserManagement,
  deactivateUserManagement,
  resetPasswordUserManagement,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  const handleNavigate = (id) => {
    if (id) {
      history.push(`/user-management/employees/${id}`);
    }
  };

  const getData = () => {
    getUserManagementList(debouncedFilter, ({ data }) =>
      handleNavigate(_.get(data, '0.id'))
    );
  };

  useEffect(() => {
    getData();

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateEmployeeModal />,
      title: 'Add User',
      modalSize: 'modal-xl',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateEmployeeModal updateList={data.attributes} id={data.id} />
      ),
      title: 'Update User',
      modalSize: 'modal-xl',
    });
  };

  const handleChangePassword = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ChangePasswordModal updateList={data.attributes} id={data.id} />
      ),
      title: 'Change User Password',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this userManagement?',
      () => {
        removeUserManagement(data.id, () => {
          getUserManagementList(INIT_FILTER);
          const id = _.get(userManagementList, '0.id');
          history.push(`/user-management/employees/${id}`);
          showUserManagement(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleActivateModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to activate this user?',
      () => {
        activateUserManagement(data.id, {}, () => {
          showUserManagement(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleDeactivateModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to deactivate this user?',
      () => {
        deactivateUserManagement(data.id, {}, () => {
          showUserManagement(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleResetPasswordModal = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to reset this user\'s password?',
      () => {
        resetPasswordUserManagement(data.id, {}, () => {
          getUserManagementList(INIT_FILTER);
          history.push(`/user-management/employees/${data.id}`);
          showUserManagement(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  // const handleFilter = (e) => {
  //   e.preventDefault();
  //   getUserManagementList({ ...formData });
  // };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:userManagementId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Employee Management"
            // getData={getUserManagementList}
            // setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:userManagementId?`}
            listName="Transaction"
            label="City Hall Employee List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  <span> {_.get(item, 'attributes.first_name')} </span>{' '}
                  <span>{_.get(item, 'attributes.last_name')}</span>
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'included.roles.attributes.name')}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.userManagementId}
            data={userManagementList}
            dataPager={userManagementListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:userManagementId?`}
                    render={() => (
                      <EmployeeUserManagementContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleChangePassword={handleChangePassword}
                        handleActivateModal={handleActivateModal}
                        handleDeactivateModal={handleDeactivateModal}
                        handleResetPasswordModal={handleResetPasswordModal}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:userManagementId?`}
                  render={() =>
                    !params.userManagementId &&
                    userManagementList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(userManagementList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

EmployeeUserManagementContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  userManagementList: PropTypes.instanceOf(Array).isRequired,
  userManagementListPager: PropTypes.instanceOf(Object).isRequired,
  removeUserManagement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  activateUserManagement: PropTypes.instanceOf(Function).isRequired,
  deactivateUserManagement: PropTypes.instanceOf(Function).isRequired,
  resetPasswordUserManagement: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  userManagementList: _.get(api, `${c.GET_USER_MANAGEMENT}.list`) || [],
  userManagementListPager: _.get(api, `${c.GET_USER_MANAGEMENT}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EmployeeUserManagementContainer);
